(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-sizing-guide"] && !Shopify.designMode) return;
  try {
    // Swap the facade for the YouTube player on click. rel=0 keeps end-screen
  // suggestions to our own channel; playsinline stops iOS jumping to fullscreen.
  // YouTube refuses to play (Error 153) without a Referer, so the policy is set
  // explicitly, matching YouTube's own embed code, rather than left to the page.
  document.addEventListener('click', (event) => {
    const facade = event.target.closest('.product-sizing-guide__facade');
    if (!facade || !facade.dataset.videoId) return;
    const iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(facade.dataset.videoId) +
      '?autoplay=1&rel=0&playsinline=1';
    iframe.title = facade.getAttribute('aria-label');
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    facade.hidden = true;
    facade.after(iframe);
  });

  // Closing the accordion hides the player but doesn't stop it, so the audio
  // would keep going. Put the facade back instead. toggle doesn't bubble, hence capture.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.open) return;
      details.querySelectorAll('.product-sizing-guide__video iframe').forEach((iframe) => {
        const facade = iframe.previousElementSibling;
        iframe.remove();
        if (facade) facade.hidden = false;
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
